import { useFeatureFlag } from "@jsq/flags-react";

/**
 * Release gate for the package staging UI, keeping the key and default in one
 * place (per the `@jsq/flags-react` wrapping-hook guidance).
 */
export function useFayPackageStaging(): boolean {
  return useFeatureFlag("fayPackageStaging", false);
}
